


























































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import HelloWorld from "@/components/HelloWorld.vue"; // @ is an alias to /src
// import {ParallaxContainer, ParallaxElement} from "vue-mouse-parallax";
// const ParallaxContainer = require("vue-mouse-parallax");
// const ParallaxElement = require("vue-mouse-parallax");

// Vue.component("parallax-container", ParallaxContainer);
// Vue.component("parallax-element", ParallaxElement);

@Component({
  components: {
    HelloWorld,
  },
})
export default class Home extends Vue {}
